/* eslint-disable import/no-extraneous-dependencies, no-useless-escape */
import { SecondaryApiTypeEnum } from '@tassat/common-definitions';
import { ApiConnectionUserMapping as FredApiConnectionUserMapping } from '@tassat/fred-extended-definitions';
import { APIConnectionRecord } from '@tassat/payments-definitions';
import { ApiConnectionUserMapping } from '@tassat/ui-definitions';

import { IErrors, IFormValues } from './types';
import {
    validateNoExcelFormulaStartingCharacters,
    validateNoNonPrintable
} from '../helpers/validationHelpers';

// TODO Move to common/constants file
export const apiConnectionUniquenessError = { [SecondaryApiTypeEnum.FIREBLOCKS]: 'A Fireblocks API connection already exists, please delete the existing connection before attempting to pair again.' };

export const validatePairApiConnections = (values: IFormValues, initialValues: IFormValues, opts: {
    userId: string;
    apiConnections: APIConnectionRecord[];
    apiConnectionUsers: ApiConnectionUserMapping[] | FredApiConnectionUserMapping[];
}) => {
    const {
        userId,
        apiConnections,
        apiConnectionUsers
    } = opts;

    const errors: IErrors = {};
    if (values.ApiConnection && values.ApiConnection?.value !== '0') {
        const existingSecondaryApi = apiConnectionUsers
            .find((apiCon) => apiCon.apiConnection && 'APISecondaryConnectionType' in apiCon.apiConnection &&
                apiCon.apiConnection.APISecondaryConnectionType === values.ApiConnection?.value);

        if (existingSecondaryApi && existingSecondaryApi.apiConnection && 'APISecondaryConnectionType' in existingSecondaryApi.apiConnection) {
            errors.ApiConnection = apiConnectionUniquenessError[existingSecondaryApi.apiConnection.APISecondaryConnectionType];
        }

        return errors;
    }

    const isUserMapped = (apiClientId: string): boolean => {
        const connection = apiConnections
            .find((conn) => conn.ClientId === apiClientId && !conn.IsDeleted);
        if (connection) {
            const isMapped = apiConnectionUsers
                .find((mapping) => mapping.apiUser.APIConnectionId === connection.APIConnectionId &&
                    mapping.apiUser.UserId === userId &&
                    !mapping.apiUser.IsDeleted);
            if (isMapped) return true;
        }

        return false;
    };

    const clientIdExcelError = validateNoExcelFormulaStartingCharacters(values.apiClientId);
    const clientIdNonPrintableError = validateNoNonPrintable(values.apiClientId);
    if (!values.apiClientId) {
        errors.apiClientId = 'Client ID required';
    } else if (isUserMapped(values.apiClientId)) {
        errors.apiClientId = 'You are already mapped to this API Connection';
    } else if (values.apiClientId.length > 40) {
        errors.apiClientId = 'Client ID length must be 40 characters or less';
    } else if (clientIdExcelError) {
        errors.apiClientId = clientIdExcelError;
    } else if (clientIdNonPrintableError) {
        errors.apiClientId = clientIdNonPrintableError;
    }

    return errors;
};